import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/var/www/apect/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/apect/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/apect/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/var/www/apect/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/apect/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/src/components/Analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/src/components/ScrollableLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/var/www/apect/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/apect/src/components/Utils/ThemeHotkey.tsx");
